// Cấp độ khoá học (giống các trang e-learning chuyên nghiệp).
export type CourseLevel = 'co_ban' | 'trung_binh' | 'nang_cao'

export const COURSE_LEVELS: { value: CourseLevel; label: string }[] = [
  { value: 'co_ban', label: 'Cơ bản' },
  { value: 'trung_binh', label: 'Trung bình' },
  { value: 'nang_cao', label: 'Nâng cao' },
]

// Khoá học online = thông tin khoá + danh sách bài giảng (theo thứ tự).
export interface CourseDoc {
  id: string
  slug: string
  ownerId?: string
  title: string
  subtitle?: string         // mô tả ngắn 1 dòng (hiển thị dưới tiêu đề)
  description?: string      // giới thiệu chi tiết
  coverImage?: string
  category?: string         // chủ đề / môn / lớp (vd: "Vật lí 11")
  level?: CourseLevel | ''  // trình độ
  access?: 'free' | 'pro'   // quyền truy cập: miễn phí hay cần PRO
  instructorName?: string       // tên giảng viên
  instructorSchool?: string     // trường / đơn vị
  instructorExperience?: string // kinh nghiệm / giới thiệu ngắn
  ratingAvg?: number            // điểm sao trung bình (server tính)
  ratingCount?: number          // số lượt đánh giá
  outcomes?: string[]       // "Bạn sẽ học được gì" (gạch đầu dòng)
  requirements?: string[]   // "Yêu cầu đầu vào"
  lessonIds: string[]       // tham chiếu tới LessonDoc.id (theo thứ tự học)
  // Tóm tắt bài giảng (server trả kèm khi getBySlug) — để trình xem không gọi API /lessons/{id} (chỉ GV).
  lessonSummaries?: { id: string; slug: string; title: string; cardCount: number }[]
  status: 'draft' | 'published'
  createdAt?: string
  updatedAt?: string
}
